<template>
    <v-responsive fluid v-resize="myEventHandler">
        <div>
            <v-card-title primary-title>
                <v-row dense justify="space-between">
                    <v-col cols="12" sm="8">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            :class="`primary--text text-overline ml-2 ${
                                $vuetify.breakpoint.xs ? 'text-center' : ''
                            }`"
                        >
                            Gestión de SVA
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            Gestión de SVA
                        </div>
                    </v-col>
                    <v-col
                        sm="4"
                        cols="12"
                        :class="`d-flex align-center ${
                            $vuetify.breakpoint.xs
                                ? 'justify-center'
                                : 'justify-end'
                        }`"
                    >
                        <!-- <v-progress-circular
                            width="2"
                            v-if="tariffManagement.isLoading"
                            :size="30"
                            color="black"
                            indeterminate
                        ></v-progress-circular> -->
                        <v-btn
                            @click="openAddingForm()"
                            color="green"
                            class="mr-2"
                            :small="$vuetify.breakpoint.mdAndDown"
                            text
                        >
                            Nuevo SVA
                            <v-icon
                                :right="!$vuetify.breakpoint.mdAndDown"
                                :small="$vuetify.breakpoint.mdAndDown"
                            >
                                mdi-pen-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-data-table
                :height="tableHeight"
                :headers="headers"
                :items="SVAManagement.svas"
                :loading="loadingItems"
                :page.sync="page"
                :footer-props="footerProps"
                :server-items-length="totalEntries"
                :options.sync="options"
                :search="search"
                class="px-2"
                hide-default-footer
            >
                <template v-slot:footer="{ props }">
                    <v-data-footer
                        style="height: 60px; justify-content: flex-end"
                        :items-per-page-options="props.itemsPerPageOptions"
                        :options.sync="options"
                        :pagination.sync="props.pagination"
                        show-first-last-page
                    >
                    </v-data-footer>
                </template>
                <template v-slot:item.is_active="{ item }">
                    <v-icon :color="item.is_active ? 'green' : 'red'">
                        mdi-circle
                    </v-icon>
                </template>
                <template v-slot:item.Actions="{ item }">
                    <v-row>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="primary"
                                text
                                @click="watchingForm(item)"
                            >
                                <v-icon> mdi-information-slab-box </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="orange"
                                text
                                @click="editingForm(item)"
                            >
                                <v-icon> mdi-pen </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="2">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="red"
                                text
                                @click="openConfirmdelete(item)"
                            >
                                <v-icon> mdi-delete-empty-outline </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </div>
    </v-responsive>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    name: 'SVAManagementTable',
    data: () => ({
        tableHeight: 300,
        footerProps: {
            itemsPerPageOptions: [0],
        },
        options: {},
        headers: [
            { text: 'Nombre', value: 'name', sortable: false  },
            { text: 'Operador', value: 'operator', sortable: false  },
            { text: 'Segmento', value: 'segment', sortable: false  },
            { text: 'Permanencia', value: 'permanence', sortable: false  },
            { text: 'Precio', value: 'price', sortable: false  },
            { text: 'Activa', value: 'is_active', sortable: true, sortable: false  },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '200px',
                sortable: false  },
        ],
    }),
    methods: {
        setForm(item) {
            this.$store.state.ManagementBase.SVAManagement.IsActive =
                item.is_active;
            this.$store.state.ManagementBase.SVAManagement.Image = item.image;
            this.$store.state.ManagementBase.SVAManagement.more_info =
                item.more_info;
            this.$store.state.ManagementBase.SVAManagement.Name = item.name;
            this.$store.state.ManagementBase.SVAManagement.Brand = item.brand;
            this.$store.state.ManagementBase.SVAManagement.SelectedSegment =
                item.segment;
            this.$store.state.ManagementBase.SVAManagement.Operator =
                item.operator;

            this.$store.state.ManagementBase.SVAManagement.Permanence =
                item.permanence;
            this.$store.state.ManagementBase.SVAManagement.Price = item.price;
            this.$store.state.ManagementBase.SVAManagement.editingId = item.id;
            this.$store.state.ManagementBase.SVAManagement.SelectedPromotions =
                item.promotions;
            this.$store.state.ManagementBase.SVAManagement.price_history =
                item.price_history;
            this.$store.state.ManagementBase.SVAManagement.upfront_history =
                item.upfront_history;
        },
        openAddingForm() {
            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'SVA';
            this.$store.state.ManagementBase.baseForm.formType = 'add';
            this.$store.state.ManagementBase.baseForm.isActive = true;
        },
        openConfirmdelete(item) {
            let deleteData = {
                module: 'ManagementBase/SVAManagement',
                item: item,
            };

            this.$store.commit('ManagementBase/confirmDeletion', {
                val: true,
                deleteData,
            });
        },
        watchingForm(item) {
            this.setForm(item);

            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'SVA';
            this.$store.state.ManagementBase.baseForm.formType = 'watch';
            this.$store.state.ManagementBase.baseForm.item_id = item.id;
            this.$store.state.ManagementBase.baseForm.isActive = item.is_active;
        },
        editingForm(item) {
            this.setForm(item);

            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'SVA';
            this.$store.state.ManagementBase.baseForm.formType = 'edit';
            this.$store.state.ManagementBase.baseForm.item_id = item.id;
            this.$store.state.ManagementBase.baseForm.isActive = item.is_active;
        },
        determineWidth() {
            let width = window.innerWidth;
            let height = 0;
            if (this.$vuetify.breakpoint.smAndDown) {
                height = 294;
            } else if (this.$vuetify.breakpoint.mdAndDown) {
                height = 234;
            } else {
                if (width < 1661) {
                    height = 258;
                } else {
                    height = 242;
                }
            }
            return height;
        },
        myEventHandler() {
            // Get width of the window
            this.tableHeight =
                document.getElementById('fullHeigth')?.clientHeight -
                this.determineWidth();
        },
        ...mapActions('ManagementBase/SVAManagement', {
            getSVA: 'getSVA',
        }),
    },
    computed: {
        page: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement
                    .SVAManagement.page;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/SVAManagement/SVAManagementPage',
                    val
                );
            },
        },
        ...mapState('ManagementBase/SVAManagement', {
            SVAManagement: (state) => state.SVAManagement,
            totalEntries: (state) => state.SVAManagement.totalEntries,
            isLoading: (state) => state.isLoading,
        }),
        ...mapState('util', {
            search: (state) => state.navBarSearchField,
        }),
        ...mapState('ManagementBase', {
            itemsPerPage: (state) => state.itemsPerPage,
            managementFiltersForm: (state) => state.managementFilters.form,
            tipoObjetivo: (state) => state.tipoObjetivo,
            loadingItems: (state) => state.loadingItems,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    watch: {
        tableHeight() {
            this.footerProps.itemsPerPageOptions[0] = Math.floor(
                this.tableHeight / 48 - 1
            );
            this.options.itemsPerPage = this.footerProps.itemsPerPageOptions[0];
        },
        managementFiltersForm: {
            deep: true,
            immediate: true,
            handler(val) {
                this.options.page = 1;
                this.$store.dispatch(
                    'ManagementBase/SVAManagement/updateSVAManagementParams',
                    { ...this.managementFiltersForm, page: 1 }
                );
                console.log('A');
                this.getSVA();
            },
        },
        options: {
            immediate: false,
            handler() {
                let page = this.options.page;
                if (
                    this.SVAManagement.page != page &&
                    !this.SVAManagement.isLoading
                ) {
                    this.$store.dispatch(
                        'ManagementBase/SVAManagement/updateSVAManagementParams',
                        this.options
                    );
                    this.getSVA();
                console.log('B');

                }
            },
            // Permite que el handler se ejecute cuando cambie cualquiera de los campos de options
            deep: true,
        },
        search() {
            // Evitar sobre cargas a la API, solo hace la peticion cuando dejas de escribir
            setTimeout(() => {
                if (!this.SVAManagement.isLoading) {
                    this.options.page = 1;
                    this.SVAManagement.page = 1;

                    this.$store.dispatch(
                        'ManagementBase/SVAManagement/updateSVAManagementParams',
                        { search: this.search }
                    );
                    this.getSVA();
                console.log('C');
                }
            }, 300);
        },
    },
};
</script>

<style>
</style>